import { CoursesType } from 'types/course.type';

export const getCourses = (data, user, profileId): CoursesType[] =>
  profileId === 'user'
    ? data?.filter((item) =>
        [...(user?.workshops || [])].map((k) => k.id).includes(item.id),
      )
    : data?.filter((item) =>
        item.teachers.some((teacher) => teacher.id.toString() === profileId),
      );

export const getEvents = (data, user, profileId): CoursesType[] => {
  const newData = data?.map((item) => ({ ...item, isWebinar: true }));
  return profileId === 'user'
    ? newData?.filter((item) =>
        [...(user?.events || [])].map((k) => k.id).includes(item.id),
      )
    : newData?.filter((item) =>
        item.teachers.some((teacher) => teacher.id.toString() === profileId),
      );
};
